import { Link } from 'react-router-dom';


export default function ResultsStart() {
  return (
    <>
      <div className="row">
        <h3 className="m-3">О разделе</h3>
      </div>
      <div className="m-3 p-4 lk-start-page">
        <p>
          В этом разделе выполняются задания МСИ: в формы заданий вносятся результаты исследований
          контрольных образцов, после чего задания отправляются на проверку в АСНП ЦВКК.
        </p>
        <ul>
          <li className="mb-2">
            <Link to="/results/tasks">Задания</Link> — задания выбранного года: материалы задания, заполнение форм,
            отправка заданий на проверку
          </li>
          <li className="mb-2">
            <Link to="/results/calendar">Календарь</Link> — сроки представления результатов по месяцам.
          </li>
          <li className="mb-2">
            <Link to="/results/reports">Результаты</Link> — отчеты о результатах исследований
            по завершенным заданиям.
          </li>
          <li className="mb-2">
            <Link to="/results/tickets">Обращения</Link> — вопросы ведущим специалистам АСНП ЦВКК
            по заданиям и результатам исследований.
          </li>
        </ul>
        <p className="mb-0 text-secondary">
          <small>Год договора меняется переключателем «год договора» в левой панели.</small>
        </p>
      </div>
    </>
  );
}
